/*
 * @Description: 收入重定向
 * @Date: 2024-12-12 11:39:23
 */

import { route } from './src/router/index';

const name = 'income-redirect';

export { name, route };
